module.exports = __webpack_public_path__ + "static/media/navidad14.c405ae89.jpg";